import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { showToast } from "Redux/General/Actions";
import { planDetails, subjectsArray } from "./subscriptionUtil";
import { UserSubscriptionValueContext } from "./SubscriptionDetails";
import { SubscriptionSubjectsWrapper } from "./SubscriptionDetails.style";

const SubscriptionSubjects = (props) => {
    const dispatch = useDispatch();
    const { setCurrentStep, subscriptionPlanDetails, setSubscriptionPlanDetails } = useContext(UserSubscriptionValueContext);
    const [selectedSubjects, setSelectedSubjects] = useState(subscriptionPlanDetails?.selectedSubjects || []);

    const handleBackButton = () => {
        setCurrentStep(1);
        // Reset to the full plan details for the current plan
        const currentPlan = planDetails.find((plan) => plan.planName === subscriptionPlanDetails.planName) || planDetails[0];
        setSubscriptionPlanDetails({
            ...currentPlan,
            selectedSubjects: [],
        });
    };

    const handleNextButton = () => {
        setCurrentStep(3);
    };

    const handleSubjectButton = (selectedId) => {
        const newSelectedSubjects = [...selectedSubjects];
        const findIndex = newSelectedSubjects.indexOf(selectedId);

        selectedSubjects.length < subscriptionPlanDetails.allowedSubjects
            ? findIndex === -1
                ? newSelectedSubjects.push(selectedId)
                : newSelectedSubjects.splice(findIndex, 1)
            : findIndex > -1
                ? newSelectedSubjects.splice(findIndex, 1)
                : dispatch(showToast("Please unselect anyone subject "));

        setSelectedSubjects(newSelectedSubjects);

        setSubscriptionPlanDetails((prev) => ({ ...prev, selectedSubjects: newSelectedSubjects }));
    };

    useEffect(() => {
        if (subscriptionPlanDetails?.allowedSubjects === 7) {
            setSelectedSubjects([1, 2, 3, 4, 5, 6, 7]);
            setSubscriptionPlanDetails((prev) => ({ ...prev, selectedSubjects: [1, 2, 3, 4, 5, 6, 7] }));
        }
        //eslint-disable-next-line
    }, []);

    return (
        <SubscriptionSubjectsWrapper>
            <div className="subject_selection_details">
                <div className="mygrid-container">
                    <div className="select-plan-plate">
                        <button className="select-plan-btn back" onClick={handleBackButton}>
                            Back
                        </button>

                        <h4 className="redfont">
                            Select{" "}
                            {subscriptionPlanDetails.allowedSubjects === 7
                                ? "all"
                                : "any"}{" "}
                            {subscriptionPlanDetails.allowedSubjects !== 7 &&
                                subscriptionPlanDetails.allowedSubjects}{" "}
                            {subscriptionPlanDetails.allowedSubjects !== 1
                                ? "subjects"
                                : "subject"}
                        </h4>

                        {/* <button className="select-plan-btn next" onClick={handleNextButton}>
                            Next
                        </button> */}

                        {subscriptionPlanDetails?.allowedSubjects === selectedSubjects.length ? (
                            <div
                                style={{
                                    backgroundColor: "#021e40",
                                    disabled: subscriptionPlanDetails?.allowedSubjects === selectedSubjects.length ? "" : "hide-visibility",
                                    color: "#fff",
                                    cursor: "pointer",
                                    padding: "10px",
                                    borderRadius: "10px",
                                }}
                                className={` ${subscriptionPlanDetails?.allowedSubjects === selectedSubjects.length ? "" : "hide-visibility"}`}
                                onClick={handleNextButton}
                            >
                                Next
                            </div>

                        ) : (
                            <div style={{ minWidth: "53px" }}></div>
                        )}
                    </div>


                    <div className="subject_selection_results">
                        {subjectsArray?.map((subjectObj) => {
                            return (
                                <div
                                    className={`subject_selcetion_item ${selectedSubjects.includes(subjectObj.subjectId) ? "selected" : ""}`}
                                    key={subjectObj.subjectId}
                                    onClick={() => handleSubjectButton(subjectObj.subjectId)}
                                >
                                    <img src={subjectObj.subjectPath} alt={subjectObj.subject} />
                                </div>

                                // <SubjectSticker
                                // 	key={subjectObj.subjectId}
                                // 	stickerImage={subjectObj?.subjectStickerImage}
                                // 	backgroundGlowColor={subjectObj?.backgroundGlowColor}
                                // 	borderColor={subjectObj?.borderColor}
                                // 	onClick={() => handleSubjectButton(subjectObj.subjectId)}
                                // 	className={selectedSubjects.includes(subjectObj.subjectId) ? "selected" : ""}
                                // />
                            );
                        })}
                    </div>
                </div>
            </div>
        </SubscriptionSubjectsWrapper>
    );
};

export default SubscriptionSubjects;